import { render } from "./FormCompound.vue?vue&type=template&id=28e36dc9"
import script from "./FormCompound.vue?vue&type=script&lang=js"
export * from "./FormCompound.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormCompound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28e36dc9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28e36dc9', __exports__)) {
    console.log('reload')
    api.reload('28e36dc9', __exports__)
  }
  
  module.hot.accept("./FormCompound.vue?vue&type=template&id=28e36dc9", () => {
    console.log('re-render')
    api.rerender('28e36dc9', render)
  })

}


export default __exports__